import React from "react";
import { Box, Typography, Container } from "@mui/material";

const TermsAndConditions = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      <Box>
        <Typography variant="h4" gutterBottom textTransform="uppercase" fontWeight="bold">
          Terms and Conditions
        </Typography>

        <Typography variant="body1" paragraph>
          Welcome to Bizstor. By accessing or using our accounting platform, you agree to abide by the following terms and conditions. Please read them carefully.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Services Provided
        </Typography>
        <Typography variant="body1" paragraph>
          Bizstor provides cloud-based business management tools including:
        </Typography>
        <ul>
          <li>Invoice Management – Create, send, and manage professional invoices.</li>
          <li>Stock & Inventory Management – Monitor stock levels and receive real-time updates.</li>
          <li>Expense Tracking – Log and manage business expenditures efficiently.</li>
          <li>Investment Management – Track capital inflows, returns, and related performance.</li>
          <li>Financial Reporting – Generate detailed insights and reports to guide decision-making.</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2. Subscription and Payment
        </Typography>
        <Typography variant="body1" paragraph>
          Bizstor offers a variety of subscription plans:
        </Typography>
        <ul>
          <li><strong>Free Plan:</strong> LKR 0.00 / month</li>
          <li><strong>Basic Plan:</strong> LKR 1,000.00 / month</li>
          <li><strong>Premium Plan:</strong> LKR 2,500.00 / month</li>
        </ul>
        <Typography variant="body1" paragraph>
          - A one-month free trial is available to all new users.<br />
          - After the trial, a paid plan is required to continue access.<br />
          - Payments are billed in advance and are non-refundable.<br />
          - Please review our Refund Policy before subscribing.
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. Data Security & Privacy
        </Typography>
        <Typography variant="body1" paragraph>
          - Bizstor adheres to strict security standards, including data encryption and secure backups.<br />
          - We do not share or sell your data to third parties, unless legally required to do so.<br />
          - Your privacy is important to us. Please refer to our Privacy Policy for more details.
        </Typography>

        <Typography variant="h6" gutterBottom>
          4. Modifications to Terms
        </Typography>
        <Typography variant="body1" paragraph>
          - We reserve the right to modify these Terms & Conditions at any time.<br />
          - Users will be notified of significant changes through email or platform alerts.
        </Typography>

        <Typography variant="h6" gutterBottom>
          5. Limitation of Liability
        </Typography>
        <Typography variant="body1" paragraph>
          - Bizstor shall not be held liable for any indirect, incidental, or consequential damages arising out of your use of the platform.<br />
          - Users are solely responsible for the accuracy and legality of their financial data.
        </Typography>

        <Typography variant="h6" gutterBottom>
          6. Contact Information
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about these terms, please contact us at: <strong>support@bizstor.lk</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          Last update: <strong>2026-07-14</strong>
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsAndConditions;
